import React, { memo } from 'react';
import { useFSPStock } from 'hooks/useFSPStock';
import StockMessageDisplay from './StockMessageDisplay';
import { StockMessageProps } from './StockDataFSPProps';

const StockMessage = memo(({ csrfToken, isFSPEnabled, fspMockEnabled, xMockResponseValue }: StockMessageProps) => {
  const { loading } = useFSPStock({
    csrfToken,
    isFSPEnabled,
    fspMockEnabled,
    xMockResponseValue,
  });

  if (loading) {
    return null;
  }

  return <StockMessageDisplay />;
});

export default StockMessage;
